module.exports = __webpack_public_path__ + "static/img/1.38b2346a.png";